<template>
  <v-card flat tile :class="'border-left--' + taskStatusColor">
    <v-row class="pa-3" justify="space-between" align="center">
      <!-- Left Part -->
      <v-col cols="12" md="7" class="py-0">
        <v-row no-gutters>
          <!-- Finished or Accepted Icon -->
          <!-- Show checked icon when when task is finished or accepted -->
          <v-icon :color="taskStatusColor" v-if="accepted">check_circle_outline</v-icon>
          <v-icon v-else-if="!accepted" :color="taskStatusColor">radio_button_unchecked</v-icon>
          <v-icon v-else color="scaleOrange">radio_button_unchecked</v-icon>

          <!-- Task name -->
          <p class="mb-0 ml-2 greyDark--text">{{ taskName }}</p>

          <span class="additional-name" v-for="(item, index) in additionalNames"
                :key="item.name + index.toString()">
            <span v-show="item.name" class="mx-5 my-auto dot--grey"></span>
            <!-- Additional Info Name 1 -->
            <v-btn
                v-if="item.asButton"
                text
                small
                color="primary"
                class="no-text-transform text-decoration-underline "
                @click.native.stop="$emit('clickedAdditional' + ++index)"
            >
              {{ item.name }}
            </v-btn>
            <p v-else class="mb-0 greyTint--text">{{ item.name }}</p>
          </span>

        </v-row>
      </v-col>

      <!-- Right part -->
      <v-col class="py-0 mt-5 mt-lg-0">
        <div class="d-flex justify-lg-end">

          <!-- Deadline -->
          <p v-if="isToday" class="mb-0 scaleGreen--text">heute</p>
          <p v-else-if="!isToday && date" class="mb-0 pt-1 greyTint--text">{{ dateAsLocalString }}</p>
          <p v-else-if="!isToday && timestamp" class="mb-0 pt-1 greyTint--text">{{ dateAsTimeString }}</p>
          <p v-else-if="period" class="mb-0 pt-1 greyTint--text">{{ period }}</p>

          <!-- TODO Priority Label -->
          <!-- <v-chip color="scaleRed" class="ml-3" small>
            <span class="font-weight-bold white--text">
              {{}}
            </span>
          </v-chip> -->

          <!-- Status Badge -->
          <v-chip v-show="taskStatusText" :color="taskStatusColor" class="ml-3" small>
            <span class="font-weight-bold white--text">
              {{ taskStatusText }}
            </span>
          </v-chip>

          <!-- Accept Task Btn -->
          <v-btn
              v-show="canAcceptTask"
              class="no-text-transform mx-3"
              color="primary"
              elevation="0"
              small
              @click.native.stop="$emit('acceptTask')"
          >
            {{ $t('buttons:accept') }}
          </v-btn>

          <!-- Decline Task Btn -->
          <v-btn
              v-show="canAcceptTask"
              class="decline-btn white--text"
              color="scaleRed"
              elevation="0"
              small
              @click.native.stop="$emit('declineTask')"
          >
            <v-icon>close</v-icon>
          </v-btn>

          <!-- Start Task Btn -->
          <v-btn
              v-show="canStartTask"
              class="no-text-transform ml-3"
              color="primary"
              elevation="0"
              small
              @click.native.stop="$emit('startTask')"
          >
            {{ $t('components:task-card.start-process') }}
          </v-btn>

          <!-- User picture who done or is assigned to this task -->
          <!-- TODO add real User pic -->
          <v-tooltip bottom v-if="!hideUser">
            <template v-slot:activator="{ on, attrs }">
              <v-avatar size="30" class="ml-3">
                <v-img
                    v-bind="attrs"
                    v-on="on"
                    src="@/assets/default_profile_pic.png"
                ></v-img>
              </v-avatar>
            </template>
            <span>{{ username }}</span>
          </v-tooltip>
        </div>
      </v-col>
    </v-row>
  </v-card>
</template>
<script>

import DateUtils from "@/modules/core/services/date-utils";

export default {
  name: 'TaskCard',
  props: {
    taskName: String,
    additionalNames: Array,
    period: String, // from .. to .. where task can be done
    date: String,
    timestamp: String,
    taskStatus: String, // 'open', 'success', 'failed', 'unassigned'
    username: String, // name of user who is responsible for task
    checkIn: Boolean,
    hideUser: Boolean,
    accepted: Boolean,
    canAcceptJobInvitation: Boolean
  },
  data() {
    return {
      dateAsLocalString: '',
      dateAsTimeString: ''
    }
  },
  computed: {
    taskStatusText() {
      if (this.taskStatus != '') {
        return this.$t('components:task-card.states.' + this.taskStatus);
      } else {
        return '';
      }
    },
    taskStatusColor() {
      if (this.taskStatus != '') {
        return 'task-list--' + this.taskStatus;
      } else {
        return '';
      }
    },

    isToday() {
      const today = new Date();
      var dateObject

      if (this.date) {
        dateObject = new Date(this.date);
      } else if (this.timestamp) {
        dateObject = DateUtils.parseDateTimeStringToDateObject(this.timestamp)
      }

      if (dateObject) {
        return today.getDate() === dateObject.getDate() &&
            today.getMonth() === dateObject.getMonth() &&
            today.getFullYear() === dateObject.getFullYear();
      } else {
        return false
      }
    },

    canAcceptTask() {
      if (this.checkIn && (this.taskStatus === 'job-invitation' || this.taskStatus === 'role-invitation')) {
        return true;
      } else if (this.taskStatus === 'job-not-accepted-future' && this.canAcceptJobInvitation) {
        return true;
      } else {
        return false;
      }
    },

    canStartTask() {
      return this.taskStatus === 'job-accepted-valid' && this.checkIn;
    }
  },
  watch: {
    date() {
      if (this.date) {
        var dateObj = new Date(this.date);
        if (!isNaN(dateObj))
          this.dateAsLocalString = dateObj.toLocaleDateString();
      }
    },
    timestamp() {
      if (this.timestamp) {
        this.dateAsTimeString = DateUtils.parseDateTimeForDisplay(this.timestamp)

      }
    }
  },
  mounted() {
    if (this.date) {
      var dateObj = new Date(this.date);
      if (!isNaN(dateObj))
        this.dateAsLocalString = dateObj.toLocaleDateString();
    }

    if (this.timestamp) {
      this.dateAsTimeString = DateUtils.parseDateTimeForDisplay(this.timestamp)
    }
  }
}
</script>
<style src="./TaskCard.scss" lang="scss"/>